import React, { useState } from 'react';
import '@/App.css';
import { Navigation } from '@/components/Navigation';
import { CursorSpotlight } from '@/components/CursorSpotlight';
import { MarqueeTicker } from '@/components/MarqueeTicker';
import { Hero } from '@/components/sections/Hero';
import { TrustBadges } from '@/components/sections/TrustBadges';
import { Services } from '@/components/sections/Services';
import { Stats } from '@/components/sections/Stats';
import { BeforeAfter } from '@/components/sections/BeforeAfter';
import { Gallery } from '@/components/sections/Gallery';
import { Testimonials } from '@/components/sections/Testimonials';
import { CtaBand } from '@/components/sections/CtaBand';
import { ContactCTA } from '@/components/sections/ContactCTA';
import { Footer } from '@/components/Footer';
import { BookingModal } from '@/components/BookingModal';

function App() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const open = () => setBookingOpen(true);

  return (
    <div className="min-h-screen bg-[#07111c] text-white overflow-x-hidden">
      <CursorSpotlight />
      <Navigation onBook={open} />
      <main>
        <Hero onBook={open} />
        <MarqueeTicker />
        <TrustBadges />
        <Services onBook={open} />
        <Stats />
        <BeforeAfter />
        <Gallery />
        <Testimonials />
        <CtaBand onBook={open} />
        <ContactCTA onBook={open} />
      </main>
      <Footer />
      <BookingModal open={bookingOpen} onClose={() => setBookingOpen(false)} />

      {/* Mobile sticky CTA */}
      <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-[#0D1B2A]/95 backdrop-blur-md border-t border-white/10 p-4 safe-area-bottom">
        <button
          onClick={open}
          className="w-full bg-[#C9A84C] text-[#0D1B2A] py-4 text-xs tracking-[0.3em] uppercase font-semibold"
          data-testid="mobile-sticky-cta"
        >
          Get a Free Quote
        </button>
      </div>
    </div>
  );
}

export default App;
